export default class ProgressGameModel {

    constructor(variableManager) {
        this._variableManager = variableManager;

        this._isNewEpiData = false;
        this._isNewHealthSystemsData = false;
        this._isNewRcceData = false;
    }

    addPath(value) {
        if (this.path) {
            this.path += value;
        } else {
            this.path = value;
        }
        this._variableManager.setVariable(`PATH_${this._path}`, true);
    }

    /** @returns {number} chapter nr, starting at 1 */
    get chapter() {
        return this._chapter;
    }

    /** @param value {number} chapter nr, starting at 1 */
    set chapter(value) {
        this._chapter = value;
    }

    /** @returns {number} week nr, starting at 1 */
    get week() {
        return this._week;
    }

    set week(value) {
        this._week = value;
    }

    /** @returns {} */
    get path() {
        return this._path;
    }

    set path(value) {
        this._path = value;
    }

    get isNewEpiData() {
        return this._isNewEpiData;
    }

    set isNewEpiData(value) {
        this._isNewEpiData = value;
    }

    get isNewHealthSystemsData() {
        return this._isNewHealthSystemsData;
    }

    set isNewHealthSystemsData(value) {
        return this._isNewHealthSystemsData = value;
    }

    get isnewRcceData() {
        return this._isNewRcceData;
    }

    set isnewRcceData(value) {
        return this._isNewRcceData = value;
    }

    toObject() {
        return {
            week: this.week,
            chapter: this.chapter,
            path: this.path
        }
    }

    fromObject(obj) {
        this.chapter = obj.chapter;
        this.week = obj.week;
        this.path = obj.path;
    }
}